import { useEffect } from 'react';
import type { RefObject } from 'react';
import { getWheelZoomFactor, zoomAroundPoint } from '../core';
import { useStoreApi } from '../store';
import { isInsideClass, isMacOs, NO_WHEEL_CLASS, rendererPoint } from '../utils';

/** Wheel and trackpad pinch zoom around the cursor; the page does not scroll (v11 `preventScrolling`). */
export const useWheelZoom = (rendererRef: RefObject<HTMLElement>): void => {
  const store = useStoreApi();
  useEffect(() => {
    const renderer = rendererRef.current;
    if (!renderer) return undefined;
    const isMac = isMacOs();
    const handleWheel = (event: WheelEvent) => {
      if (isInsideClass(event.target, NO_WHEEL_CLASS)) return;
      event.preventDefault();
      const { viewport, minZoom, maxZoom, setViewport } = store.getState();
      const zoom = viewport.zoom * getWheelZoomFactor(event, isMac);
      setViewport(zoomAroundPoint(viewport, rendererPoint(renderer, event), zoom, { minZoom, maxZoom }));
    };
    renderer.addEventListener('wheel', handleWheel, { passive: false });
    return () => renderer.removeEventListener('wheel', handleWheel);
  }, [rendererRef, store]);
};
